import * as XLSX from 'xlsx';

export async function initCrosssellerFromExcel(selector = '.js-crosssellerSelection') {
    try {
        const containers = document.querySelectorAll(selector);
        if (!containers.length) {
            return;
        }

        for (const container of containers) {
            const file = container.dataset.file;
            if (!file) {
                continue;
            }

            // Automatische Spracherkennung für gesamtliste-Dateien
            let fileToLoad = file;
            const languageCode = GLOBALS.languageCode;

            // Wenn es eine gesamtliste.xls ist, versuche die sprachspezifische Version zu laden
            if (languageCode && file.includes('gesamtliste') && !file.includes(`-${languageCode}`)) {
                const fileExt = file.substring(file.lastIndexOf('.'));
                // Vorhandenes Sprachsuffix entfernen (z.B. -de, -en) bevor das neue hinzugefügt wird
                let fileBase = file.substring(0, file.lastIndexOf('.'));
                fileBase = fileBase.replace(/-[a-z]{2}$/, '');
                const localizedFile = `${fileBase}-${languageCode}${fileExt}`;

                // Prüfe ob die sprachspezifische Datei existiert
                try {
                    const testResp = await fetch(localizedFile, { method: 'HEAD' });
                    if (testResp.ok) {
                        fileToLoad = localizedFile;
                    }
                } catch (e) {
                    // Fallback zur ursprünglichen Datei
                    console.log(`Sprachspezifische Datei nicht gefunden: ${localizedFile}, verwende ${file}`);
                }
            }

            const resp = await fetch(fileToLoad);
            if (!resp.ok) throw new Error(`Datei nicht gefunden: ${fileToLoad}`);
            const buf = await resp.arrayBuffer();
            const wb = XLSX.read(buf, { type: 'array' });
            const sheet = wb.Sheets[wb.SheetNames[0]];
            const rawData = XLSX.utils.sheet_to_json(sheet, { defval: '' });

            if (rawData.length === 0) {
                console.error('Keine Daten im Sheet', file);
                continue;
            }

            const keys = Object.keys(rawData[0]);
            const normalize = str =>
                str.toString().trim().normalize('NFD').replace(/[̀-\u036f]/g, '').toLowerCase();

            let herstellerKey = null;
            let produktKey = null;
            let linkKey = null;

            keys.forEach(key => {
                const norm = normalize(key);
                if (/(hersteller|lieferant|vendor)/.test(norm)) herstellerKey = key;
                if (/(produkt|artikel|bezeichnung)/.test(norm)) produktKey = key;
                if (/(link|url)/.test(norm)) linkKey = key;
            });

            if (!linkKey && keys.length >= 3) {
                linkKey = keys[2];
            }

            if (!herstellerKey || !produktKey) {
                console.error(`Spalten "Hersteller" oder "Produkt" nicht gefunden in ${file}`);
                continue;
            }

            // Daten aufbereiten
            const data = rawData.map(row => ({
                hersteller: row[herstellerKey],
                produkt: row[produktKey],
                link: linkKey ? row[linkKey] : ''
            })).filter(o => o.hersteller && o.produkt);

            buildDropdowns(container, data);
        }
    } catch (err) {
        console.error('Excel-Init-Fehler:', err);
    }
}

function buildDropdowns(container, data) {
    container.innerHTML = '';

    const selHer = document.createElement('select');
    selHer.innerHTML = [`
        <option value="">${GLOBALS.tc.choose_brand}…</option>
    `, ...Array.from(new Set(data.map(d => d.hersteller))).sort((a,b)=>a.localeCompare(b,'de')).map(m=>`<option value="${m}">${m}</option>`)
    ].join('');

    const selProd = document.createElement('select');
    selProd.innerHTML = `<option value="">${GLOBALS.tc.choose_product}…</option>`;
    selProd.disabled = true;

    selHer.addEventListener('change', () => {
        const h = selHer.value;
        selProd.disabled = !h;
        selProd.innerHTML = `<option value="">${GLOBALS.tc.choose_product}…</option>`;
        if (h) {
            const options = data.filter(d => d.hersteller === h)
                .sort((a,b)=>a.produkt.localeCompare(b.produkt,'de'))
                .map(d => `<option value="${encodeURIComponent(d.link)}">${d.produkt}</option>`);
            selProd.innerHTML += options.join('');
        }
    });

    selProd.addEventListener('change', () => {
        const link = decodeURIComponent(selProd.value);
        if (link) window.open(link, '_blank');
    });

    container.append(selHer, selProd);
}
